import React from 'react';

import { LoanTermTabs } from '../../FinancingSection/LoanTermTabs';

import { FinanceLenders } from './FinanceLenders';

import { Loader } from '../../Elements/Loader';

import { AUTO } from '../../../constants/ComparisonSummary';
import { AUTO_OR_MORTGAGE_LOAN_TERMS } from '../../../constants/Dashboard/Financing';

import './FinanceRatesAndLenders.css';

export const FinanceRatesAndLenders = ({
  isLoading = false,
  isRatesTableFullScreen = true,
  financingType = AUTO,
  selectedLoanTerms = {},
  lenders = {},
  selectedLoanTermInMonths = {},
}) => {
  return (
    <div className="finance-rates-lenders-loan-term-wrapper">
      {isLoading ? (
        <div className="summary-loan-term-tabs-loader-wrapper">
          <Loader size={60} />
        </div>
      ) : (
        <>
          {' '}
          <div className="summary-loan-term-tabs-wrapper">
            <LoanTermTabs
              selectedLoanTerms={selectedLoanTerms}
              handleLoanTermClick={() => {}}
              financeLoanTerms={AUTO_OR_MORTGAGE_LOAN_TERMS[financingType]}
            />
          </div>
          <FinanceLenders
            financingType={financingType}
            isRatesTableFullScreen={isRatesTableFullScreen}
            selectedLoanTerms={
              financingType === AUTO ? selectedLoanTerms : selectedLoanTermInMonths
            }
            lenders={lenders}
          />
        </>
      )}
    </div>
  );
};
